import { create } from "zustand"
import { AppointmentAttachment } from "@/modules/patients/components/attachments/attachment-item"

interface PreviewDocumentDialogStore {
  mediaFiles: AppointmentAttachment[] | null
  setMediaFiles: (preview: AppointmentAttachment[] | null) => void
  closePreviewDocumentDialog: () => void
  index: number
  setIndex: (index: number) => void
  previewDocumentAppointmentId?: string
  setPreviewDocumentAppointmentId: (appointmentId?: string) => void
}

export const usePreviewDocumentDialogStore = create<PreviewDocumentDialogStore>((set) => ({
  mediaFiles: null,
  index: -1,
  previewDocumentAppointmentId: undefined,
  setPreviewDocumentAppointmentId: (appointmentId) => set({ previewDocumentAppointmentId: appointmentId }),
  setIndex: (index) => set({ index }),
  setMediaFiles: (previewDocumentDialogParams) => set({ mediaFiles: previewDocumentDialogParams }),
  closePreviewDocumentDialog: () => set({ mediaFiles: null }),
}))
